// reducers/eventReducer.js
export const eventReducer = (
  state = { events: [], calendar: null },
  action,
) => {
  switch (action.type) {
    case "EVENT_REQUEST":
    case "CALENDAR_REQUEST":
      return { ...state, loading: true, error: null, success: false };

    case "GET_EVENTS_SUCCESS":
      return { ...state, loading: false, events: action.payload };

    case "CALENDAR_SUCCESS":
      return { ...state, loading: false, calendar: action.payload };

    case "CREATE_EVENT_SUCCESS":
      return {
        loading: false,
        success: true,
        events: [...state.events, action.payload],
        calendar: state.calendar,
      };

    case "UPDATE_EVENT_SUCCESS":
      return {
        loading: false,
        success: true,
        events: state.events.map((e) =>
          e.id === action.payload.id ? action.payload : e,
        ),
        calendar: state.calendar,
      };

    case "DELETE_EVENT_SUCCESS":
      return {
        loading: false,
        success: true,
        events: state.events.filter((e) => e.id !== action.payload),
        calendar: state.calendar,
      };

    case "EVENT_NOTIFY_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        events: state.events.map((e) =>
          e.id === action.payload ? { ...e, notification_sent: true } : e,
        ),
      };

    case "CALENDAR_FAIL":
    case "EVENT_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
